import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../context/CookieConsentContext';
import { useI18n } from '../i18n/I18nContext';
import { getCookieConsentCopy } from '../i18n/cookieConsentCopy';
import '../style/CookieConsent.css';

const categoryKeys = ['preferences', 'analytics', 'diagnostics'];

const CookieConsentBanner = () => {
  const { language } = useI18n();
  const copy = getCookieConsentCopy(language);
  const {
    consentLoaded, hasDecision, isSettingsOpen, closeSettings, preferences, analytics, diagnostics,
    savePreferences, acceptAll, essentialOnly,
  } = useCookieConsent();
  const [isManaging, setIsManaging] = useState(false);
  const [choices, setChoices] = useState({ preferences: false, analytics: false, diagnostics: false });

  useEffect(() => {
    setChoices({ preferences, analytics, diagnostics });
  }, [preferences, analytics, diagnostics, isSettingsOpen]);

  useEffect(() => {
    if (!hasDecision) setIsManaging(false);
  }, [hasDecision]);

  if (!consentLoaded || (hasDecision && !isSettingsOpen)) return null;

  const showManager = isManaging || isSettingsOpen;
  const closeManager = () => {
    if (hasDecision) closeSettings();
    else setIsManaging(false);
  };

  return (
    <div className="cookie-consent-layer" role="presentation">
      <section className="cookie-consent-banner" role="dialog" aria-modal="true" aria-labelledby="cookie-consent-title">
        <div className="cookie-consent-heading">
          <p className="eyebrow">Fate Room</p>
          <h2 id="cookie-consent-title">{copy.title}</h2>
          <p>{copy.description}</p>
        </div>

        {showManager && (
          <div className="cookie-consent-options">
            <CookieOption title={copy.necessary[0]} state={copy.necessary[1]} description={copy.necessary[2]} checked disabled />
            {categoryKeys.map((key) => (
              <CookieOption
                key={key}
                title={copy[key][0]}
                state={copy[key][1]}
                description={copy[key][2]}
                checked={choices[key]}
                onChange={() => setChoices((current) => ({ ...current, [key]: !current[key] }))}
              />
            ))}
          </div>
        )}

        <div className="cookie-consent-actions">
          {showManager ? (
            <>
              <button type="button" className="secondary-button" onClick={closeManager}>{copy.back}</button>
              <button type="button" className="primary-button" onClick={() => savePreferences(choices)}>{copy.save}</button>
            </>
          ) : (
            <>
              <button type="button" className="secondary-button" onClick={essentialOnly}>{copy.rejectOptional}</button>
              <button type="button" className="secondary-button" onClick={() => setIsManaging(true)}>{copy.manage}</button>
              <button type="button" className="primary-button" onClick={acceptAll}>{copy.acceptAll}</button>
            </>
          )}
        </div>

        <div className="cookie-consent-footer">
          <Link to="/cookie-policy" onClick={closeManager}>{copy.policy}</Link>
          <span>{copy.note}</span>
        </div>
      </section>
    </div>
  );
};

function CookieOption({ title, state, description, checked, disabled, onChange }) {
  return (
    <label className="cookie-consent-option">
      <span>
        <strong>{title}</strong>
        <small>{description}</small>
      </span>
      <span className="cookie-consent-switch-wrap">
        <em>{state}</em>
        <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange} />
      </span>
    </label>
  );
}

export default CookieConsentBanner;
